import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class VendorSalespersonResource extends BaseResource {
    pk() {
        return this.key?.toString();
    }
    static merge(first, second) {
        return second;
    }
}
VendorSalespersonResource.urlRoot = legacyApiResourceUrl("Reassignment.ReassignApplications/GetAvailableSalespesonsWithVendor");
export { VendorSalespersonResource };
//# sourceMappingURL=VendorSalespersonResource.js.map